import React, { useEffect, useState } from 'react';
import SupervisorBankSearchModal from './SupervisorBankSearchModal';
import { listSupervisedBanks } from '../api/supervisor';
import { labelWithSeq } from './ScopeField';
import { normalizeBankSeq } from '../api/banks';

/**
 * Variante SUPERVISEUR de BankScopeField (memes props : id / name / onResolve /
 * classes) — pour reutiliser telles quelles les pages Central de la company
 * cote superviseur (2026-09-26). Ne connait que les banks du superviseur
 * connecte (listSupervisedBanks, deja limite cote backend a
 * Supervisor.covered_bank_ids()) : on tape son username (8 chiffres) OU son
 * numero (Bank.seq), resolution au blur ; 🔍 -> SupervisorBankSearchModal.
 * `id` renvoye = id interne (utilise par les appels API), la case garde le
 * texte tape/choisi.
 */
export default function SupervisorBankScopeField({
  id,
  name = '',
  onResolve,
  inputClass = '',
  iconClass = '',
  nameClass = '',
  errClass = '',
}) {
  const [text, setText] = useState('');
  const [err, setErr] = useState('');
  const [modalOpen, setModalOpen] = useState(false);

  // L'id a ete efface ailleurs (ex: reset du formulaire) -> vide aussi la case.
  useEffect(() => { if (!id) setText(''); }, [id]);

  const resolve = async () => {
    const t = text.trim();
    if (t === '') { setErr(''); onResolve('', ''); return; }
    const banks = await listSupervisedBanks().catch(() => []);
    const seq = normalizeBankSeq(t); // "19-19" / "05" (REF de la fiche) -> "19" / "5"
    const bank = banks.find((b) => b.username === t) || (seq && banks.find((b) => String(b.seq) === seq));
    if (bank) { setErr(''); onResolve(String(bank.id), labelWithSeq(bank.seq, bank.name)); } else { setErr('Banque introuvable'); }
  };

  return (
    <>
      <input
        className={inputClass}
        type="text"
        inputMode="numeric"
        value={text}
        onChange={(e) => { setText(e.target.value); setErr(''); }}
        onFocus={(e) => e.target.select()}
        onBlur={resolve}
      />
      <span className={iconClass} onClick={() => setModalOpen(true)}>🔍</span>
      {err
        ? <span className={errClass || nameClass} style={{ color: '#c0392b' }}>{err}</span>
        : (name ? <span className={nameClass}>{name}</span> : null)}
      {modalOpen && (
        <SupervisorBankSearchModal
          onSelect={(bid, bname, busername, bseq) => {
            setText(busername || (bseq != null ? String(bseq) : ''));
            setErr('');
            onResolve(String(bid), labelWithSeq(bseq, bname));
          }}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
}
